import { SubscriptionRegistrationTokenSavedById } from 'graphql/generated/graphqlTypes';

export function generateMockSubscriptionRegistrationToken({
  mobileDeviceId = 'subscriptionRegistrationTokenMobileDeviceId',
  registrationToken = 'subscriptionRegistrationTokenRegistrationToken',
  visitorId = 'subscriptionRegistrationTokenVisitorId'
}: Partial<Omit<SubscriptionRegistrationTokenSavedById, '__typename'>>): SubscriptionRegistrationTokenSavedById {
  return {
    __typename: 'SubscriptionRegistrationTokenSavedById',
    mobileDeviceId,
    registrationToken,
    visitorId
  };
}
